import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { StatusTypeService } from '../../services/status-type.service';
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { CommonModule } from '@angular/common';
import { MatTabsModule } from "@angular/material/tabs";
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { RekbotStatusType } from '../../models/rekbot-status-type.model';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatIcon } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatDialog } from '@angular/material/dialog';
import { ModalStatusTypeFormComponent } from './modal-status-type-form/modal-status-type-form.component';
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-rekbot-status-type',
  imports: [
    MatProgressSpinner,
    CommonModule,
    MatTabsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatIcon,
    MatMenuModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule
],
  templateUrl: './rekbot-status-type.component.html',
  styleUrl: './rekbot-status-type.component.css'
})
export class RekbotStatusTypeComponent implements OnInit, AfterViewInit{
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  isLoading?:boolean;
  errorMessage:string = "";

  displayedColumns: string[] = ['id','name','description','instruction','type','action'];

  statusTypes: RekbotStatusType[] = [];
  dataSource = new MatTableDataSource<RekbotStatusType>(this.statusTypes);
  filter: FormControl = new FormControl('');
  storageFilterName = "statusTypeNameFilter";

  

  constructor(
    private statusTypeService: StatusTypeService,
    readonly dialog: MatDialog,
    private snackBar: MatSnackBar,
  ){
    this.filter.valueChanges
    .pipe(
      takeUntilDestroyed(),
      finalize(() => console.log('UNSUBSCRIBE: filter message type'))
      )
    .subscribe(value => {
      console.log("filtrowanie: ", value);
      this.dataSource.filter = value;
    });
  }

  ngOnInit(): void {
    this.fetchStatusTypes();

    

    const filterValue = sessionStorage.getItem(this.storageFilterName) ?? "";

    if(filterValue) {
      this.filter.setValue(filterValue);
      this.dataSource.filter = filterValue;
    } 
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    
    
  }
  
  fetchStatusTypes() {
    console.log('FetchStatus');
    this.isLoading = true
    this.statusTypeService.getAllStatusTypes().subscribe({
      next: res => {
        // console.log("wynik message type service: ", res);
        this.statusTypes = res
        // console.log("Wczytane wiadomości: ", this.messageTypes)
        this.dataSource.data = this.statusTypes

        this.isLoading = false;
      },
      error: err => {
        console.log("BŁĄD");
        this.isLoading = false;
        this.errorMessage = "Nie udało się wczytać danych: " +err.status 
        console.error(err);
        
      }
    })
  }

  onOpenStatusTypeForm(id?:string) {
    if(id){
      console.log("Edytowanie: ", id);
      const dialogRef = this.dialog.open(ModalStatusTypeFormComponent, 
        {data: id});
      dialogRef.afterClosed().subscribe(result => {
      console.log('Modal zamknięty, result:', result);
      if(result) {
        this.fetchStatusTypes()
      }
      });
    } else {
      console.log("Dodawanie: ");
      const dialogRef = this.dialog.open(ModalStatusTypeFormComponent)
      dialogRef.afterClosed().subscribe(result => {
      console.log('Modal zamknięty, result:', result);
      if(result) {
        this.fetchStatusTypes()
      }
      });
    }

    

    
    
  }

  onDeleteStatusType(id:string) {
    const confirmed = confirm("Czy na pewno chcesz usunąć typ wiadomości?");
    if(confirmed) {
      this.statusTypeService.removeStatusType(id)
      .subscribe({
        next: () => {
          this.snackBar.open("Pomyślnie usunięto typ wiadomości", "OK",{duration:2000});
          this.fetchStatusTypes();
        },
        error: () => this.snackBar.open("Coś poszło nie tak :/", "",{duration:2000})
      });
    }
  }

  saveFilter() {
    console.log("Zapisz filter:", this.filter.getRawValue());
    
    sessionStorage.setItem(this.storageFilterName,this.filter.getRawValue());

  }

  clearFilter() {
    this.filter.setValue('');
    sessionStorage.removeItem(this.storageFilterName);
  }
}
